import React from "react";
import { FormattedDate } from "react-intl";

const Clock = (props) => {
  const [date, setDate] = React.useState(new Date());

  //Replaces componentDidMount and componentWillUnmount
  React.useEffect(() => {
    var timerID = setInterval(() => tick(), 1000);
    return function cleanup() {
      clearInterval(timerID);
    };
  }, []); // Empty dependency array ensures interval is only set up once

  function tick() {
    setDate(new Date());
  }

  return (
    <div>
      <FormattedDate
        value={date}
        year="numeric"
        month="long"
        day="2-digit"
        hour="numeric"
        minute="numeric"
        second="numeric"
        weekday="short"
      />
    </div>
  );
};

export default Clock;
